/******************************** Import Package ************************************/
import React from "react";
import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
} from "@mui/material";

/******************************** Select ************************************/
export default function Select(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    options,
    defaultValue,
    valuesOnly,
    capitalize,
    ...other
  } = props;

  return (
    <FormControl
      variant="outlined"
      error={Boolean(error)} // ✅ Updated error handling
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        {...other}
      >
        {!valuesOnly && <MenuItem value="">None</MenuItem>}
        {options.map((item) => (
          <MenuItem
            key={item.id}
            value={item.id}
            className={capitalize ? "capitalize" : ""}
          >
            {item.title}
          </MenuItem>
        ))}
      </MuiSelect>

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
